import { Fragment, useState } from "react";
import PropTypes from "prop-types";
import MandatoryEditableCell from "../MandatoryEditableCell/MandatoryEditableCell";
import { ReactComponent as BulletIcon } from "assets/icons/bullet.svg";
import "./editableRow.scss";

const EditableRow = ({ food, handleLogChange }) => {
    const {
        title,
        order_count,
        order_item_id,
        receiving_count,
        good_id,
        sum_of_order_count,
        sum_of_receiving_count,
    } = food;
    const [variance, setVariance] = useState(
        Number(receiving_count) - Number(order_count)
    );

    const logChangeInput = (id, value) => {
        handleLogChange(id, value);
        const varianceValue =
            value + sum_of_receiving_count - sum_of_order_count;
        setVariance(varianceValue);
    };

    return (
        <Fragment>
            <tr className="tr new-kitchen-table-editable-row">
                <td className="td title">
                    <span className="bullet-icon">
                        <BulletIcon className="ml-2" />
                    </span>
                    {title}
                </td>
                <td className="td">{sum_of_order_count}</td>
                <td className="td">{sum_of_receiving_count}</td>
                <td className="td">
                    <MandatoryEditableCell
                        item={{
                            good_id,
                            order_item_id,
                            defaultValue: receiving_count,
                        }}
                        handleLogChange={logChangeInput}
                    />
                </td>
                <td className="td">
                    {variance === 0 && (
                        <span className={"variance ltr"}>0</span>
                    )}
                    {variance !== 0 && (
                        <span className={`variance haveVariance ltr`}>{`${
                            variance > 0 ? "+" + variance : variance
                        }`}</span>
                    )}
                </td>
            </tr>
        </Fragment>
    );
};

EditableRow.propTypes = {
    food: PropTypes.object,
    handleLogChange: PropTypes.func,
};

export default EditableRow;
